<template>
	<section class="form-group FormDateTime" :data-entry="id || name">
		<label v-if="label" class="title" :for="id || name" :class="{ required }">{{ label }}</label>
		<div class="input-area">
			<i v-if="icon" :class="{ [`icon-${icon}`]: true }"></i>
			<input class="input" :type="type" :id="`${formId}_${id || name}`" v-bind="$attrs" :value="value" @input="$emit('change', $event.target.value)" />
		</div>
	</section>
</template>

<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
};
</script>

<style scoped lang="scss">
.FormDateTime {
	.input-area {
		input {
			outline: none;
			border: none;
			padding: 1rem 1.5rem;
			background-color: var(--backgroundColor);
			border-radius: 0.5rem;
			font-size: inherit;
		}
	}
}
</style>
